// extracted by mini-css-extract-plugin
module.exports = {"skjemadetaljerPreviewPage":"SkjemadetaljerPreviewPage_skjemadetaljerPreviewPage__E4b1t"};